import React, { FC } from 'react';
import { Button } from '@firesoon/antd';
import { ButtonDecorator } from './interface';
import { ButtonProps as AntdButtonProps, ButtonSize, ButtonType } from '@firesoon/antd/lib/button/button';
import './index.less';

const { Group } = Button;

export interface ButtonProps extends Omit<AntdButtonProps, 'type' | 'size'> {
  /** 按钮尺寸，可不传，默认default，次按钮 */
  size?: ButtonSize | 'xl';
  /** 按钮种类，可不传，默认default，常规 M */
  type?: ButtonType | 'icon' | 'reverse';
  disabled?: boolean;
  /** 埋点数据 */
  dataName?: string;
  /** 按钮背景色是否填充白色，多用于幽灵按钮 */
  filled?: boolean;
}

const Index: FC<ButtonProps> = ({ className = '', type = 'default', children, size = 'default', filled, ...rest }) => {
  const isIcon = type === 'icon';
  const { loading, disabled } = rest;

  const formatClassName = () => {
    let result = `fs-btn ${className}`;
    if (size === 'xl') {
      result = `${result} fs-btn-xl`;
    }
    if (isIcon) {
      result = `${result} fs-btn-icon ant-btn-primary`;
    }
    if (type === 'reverse') {
      result = `${result} fs-btn-reverse`;
    }
    if (filled) {
      result = `${result} fs-btn-filled`;
    }

    return result;
  };

  return (
    <Button
      ghost={type === 'dashed' && disabled}
      className={formatClassName()}
      size={size === 'xl' ? 'default' : size}
      type={type === 'icon' || type === 'reverse' ? 'default' : type}
      {...rest}
    >
      {isIcon && loading ? '' : children}
    </Button>
  );
};

Object.assign(Index, {
  Group,
});

export default Index as ButtonDecorator;
